import { styled, Theme, useMediaQuery } from '@mui/material';
import { WBFlex } from '@admiin-com/ds-web';
import { TextFormField } from '../../../../../components/ESignature/SignatureForm';
import { TaskPropertyProps } from './types';
export const TaskPropertyDesktop = (props: TaskPropertyProps) => {
  const isTablet = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down('md')
  );
  if (isTablet || props.properties.length === 0) {
    return null;
  }
  return (
    <Header>
      {props.properties.map((property) => (
        <TextFormField
          label={property.label}
          value={property.value}
          key={property.label}
        />
      ))}
    </Header>
  );
};

const Header = styled(WBFlex)(({ theme }) => ({
  background: theme.palette.background.paper,
  width: '100%',
  padding: theme.spacing(3, 10),
  gap: theme.spacing(3),
}));
